import { render, staticRenderFns } from "./DutiesListVigilancePage.vue?vue&type=template&id=19fc8ae0"
import script from "./DutiesListVigilancePage.vue?vue&type=script&lang=js"
export * from "./DutiesListVigilancePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports